import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PostAppointmentBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Creates a new appointment directly (staff-initiated, no booking link flow). */
export function useCreateAppointment() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: PostAppointmentBody) => {
      const response = await api.post('/appointments', { body })
      if (!response.success) {
        throw new Error(response.error.message)
      }
      return response.data
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['appointments'] })
      // The patientId is on the request body, so we can invalidate the scoped key too.
      queryClient.invalidateQueries({ queryKey: ['patient-appointments', variables.patientId] })
      queryClient.invalidateQueries({ queryKey: ['patient-timeline', variables.patientId] })
      // Immediately remove the booked slot from the availability overlay.
      queryClient.invalidateQueries({ queryKey: ['available-slots-range'] })
    },
  })
}
